import { render, staticRenderFns } from "./ProjectMaster.vue?vue&type=template&id=3fc4d52b&"
import script from "./ProjectMaster.vue?vue&type=script&lang=js&"
export * from "./ProjectMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports